<template>
  <!-- V-select that shows donation causes in a nicer way (with logos)
   Unlike the DonationCauseAutocomplete we don't do async searching or retrieve items but rather they are passed as prop -->
  <v-select
    v-model="donationCause"
    :clearable="clearable"
    :disabled="disabled"
    :hide-details="hideDetails"
    :items="donationCauses"
    :placeholder="t('donationDetails.form.donationCauseId.autoComplete.selectAFund')"
    :readonly="readOnly"
    :rules="rules"
    item-text="name"
    :label="t('donationDetails.form.donationCauseId.autoComplete.fund')"
    :no-data-text="t('donationDetails.form.donationCauseId.autoComplete.noFundsToSelect')"
    return-object
    @change="$emit('change')"
    @click:clear="$emit('clear')"
  >
    <template #item="{ item }">
      <v-list-item-media v-if="item.logoUrl && item.logoUrl.length > 0">
        <v-img
          :alt="
            t('donationDetails.form.donationCauseId.autoComplete.logoAltText', {
              causeName: item.name,
            })
          "
          :src="item.logoUrl"
        />
      </v-list-item-media>
      <div class="v-list-item__content">
        <v-list-item-title>
          {{ item.name }}
        </v-list-item-title>
        <v-list-item-subtitle>
          <span v-if="item.organizationGroup && item.organizationGroup.name !== item.name"
            >{{
              t('donationDetails.form.donationCauseId.autoComplete.fundName', {
                fundName: item.organizationGroup.name,
              })
            }}
            |
          </span>
          <span
            v-if="item.organizationGroup && item.organizationGroup.giro"
            class="font-weight-medium"
            >{{ item.organizationGroup.giro }}</span
          >
        </v-list-item-subtitle>
      </div>
    </template>
  </v-select>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
// prefer useLabel composable for translations
import { useLabel } from '@/composables/useLabel';
import { DonationCause } from '@/interfaces/organizationgroup/donationCause';
// label helper available as useLabel composable if needed

export default defineComponent({
  // no mixins required
  props: {
    disabled: { type: Boolean, default: false },
    readOnly: { type: Boolean, default: false },
    clearable: { type: Boolean, default: true },
    hideDetails: { type: Boolean, default: true },
    value: { type: Object as () => DonationCause, default: null },
    donationCauses: { type: Array as () => DonationCause[], default: () => [] },
    rules: { type: Array as () => ((value) => string | boolean)[], default: () => [] },
  },
  emits: ['update:value', 'change', 'clear'],
  setup(props, { emit }) {
    const { t } = useLabel();

    const donationCause = computed({
      get: () => props.value || ({} as DonationCause),
      set: (newValue: DonationCause) => emit('update:value', newValue),
    });

    return {
      t,
      donationCause,
    };
  },
});
</script>
